var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 18.334L1.66602 18.334",
    stroke: "#7F8594",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1673 18.3327V4.99935C14.1673 3.428 14.1673 2.64233 13.6792 2.15417C13.191 1.66602 12.4053 1.66602 10.834 1.66602H9.16732C7.59597 1.66602 6.8103 1.66602 6.32214 2.15417C5.83398 2.64233 5.83398 3.428 5.83398 4.99935V18.3327",
    stroke: "#7F8594",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5007 18.3327V9.58268C17.5007 8.4123 17.5007 7.8271 17.2198 7.40673C17.0982 7.22475 16.9419 7.0685 16.7599 6.9469C16.3396 6.66602 15.7544 6.66602 14.584 6.66602",
    stroke: "#7F8594",
    strokeWidth: 1.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18.3327V9.58268C2.5 8.4123 2.5 7.8271 2.78088 7.40673C2.90248 7.22475 3.05873 7.0685 3.24072 6.9469C3.66109 6.66602 4.24628 6.66602 5.41667 6.66602",
    stroke: "#7F8594",
    strokeWidth: 1.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.334V15.834",
    stroke: "#7F8594",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 4.16602H11.6673",
    stroke: "#7F8594",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 6.66602H11.6673",
    stroke: "#7F8594",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 9.16602H11.6673",
    stroke: "#7F8594",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 11.666H11.6673",
    stroke: "#7F8594",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/buildings.ec322154.svg";
export { ForwardRef as ReactComponent };